import * as React from 'react';

const BasicCard = ({ children }) => {
  return (

  
      <div class="card col-md-9 m-autos Basic mt-4  pl-5 shadow p-3 mb-5 bg-body rounded">
          {children}
      </div>
   
  );
}
export default BasicCard;